import React from 'react';
import { Input } from './ui/Input';
import { Select } from './ui/Select';
import { Button } from './ui/Button';
import { Trash2 } from 'lucide-react';
export interface InterestSlab {
  id: string;
  type: 'Percentage' | 'Fixed' | 'Fixed + Percentage';
  slabLow: string;
  slabHigh: string;
  value: string;
  fixedAmount?: string;
  minCap: string;
  maxCap: string;
  glAccount: string;
  tax: string;
}
interface InterestSlabRowProps {
  slab: InterestSlab;
  index: number;
  onChange: (id: string, updates: Partial<InterestSlab>) => void;
  onRemove: (id: string) => void;
  isFirst: boolean;
}
export function InterestSlabRow({
  slab,
  index,
  onChange,
  onRemove,
  isFirst
}: InterestSlabRowProps) {
  return <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 relative animate-in fade-in slide-in-from-bottom-2 duration-300" data-id="element-306">
      <div className="absolute -top-3 left-4 bg-gray-100 px-2 py-0.5 rounded text-xs font-medium text-gray-500 border border-gray-200" data-id="element-307">
        Slab {index + 1}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4" data-id="element-308">
        {/* Row 1: Type and Range */}
        <div className="md:col-span-3" data-id="element-309">
          <Select label="Type" value={slab.type} onChange={e => onChange(slab.id, {
          type: e.target.value as any
        })} options={[{
          value: 'Percentage',
          label: 'Percentage'
        }, {
          value: 'Fixed',
          label: 'Fixed Amount'
        }, {
          value: 'Fixed + Percentage',
          label: 'Fixed + Percentage'
        }]} data-id="element-310" />
        </div>

        <div className="md:col-span-3" data-id="element-311">
          <Input label="Slab Low" type="number" value={slab.slabLow} onChange={e => onChange(slab.id, {
          slabLow: e.target.value
        })} placeholder="0" data-id="element-312" />
        </div>

        <div className="md:col-span-3" data-id="element-313">
          <Input label="Slab High" type="number" value={slab.slabHigh} onChange={e => onChange(slab.id, {
          slabHigh: e.target.value
        })} placeholder="Unlimited" data-id="element-314" />
        </div>

        <div className="md:col-span-3" data-id="element-315">
          <Select label="GL Account" value={slab.glAccount} onChange={e => onChange(slab.id, {
          glAccount: e.target.value
        })} options={[{
          value: '4100',
          label: '4100 - Interest Income'
        }, {
          value: '4200',
          label: '4200 - Markup Revenue'
        }, {
          value: '4300',
          label: '4300 - Fee Income'
        }]} data-id="element-316" />
        </div>

        {/* Row 2: Values and Caps */}
        <div className="md:col-span-3" data-id="element-317">
          <Input label={slab.type === 'Fixed' ? 'Fixed Amount' : 'Percentage (%)'} type="number" value={slab.value} onChange={e => onChange(slab.id, {
          value: e.target.value
        })} placeholder={slab.type === 'Fixed' ? '500' : '15.5'} data-id="element-318" />
        </div>

        {slab.type === 'Fixed + Percentage' && <div className="md:col-span-3" data-id="element-319">
            <Input label="Fixed Amount" type="number" value={slab.fixedAmount || ''} onChange={e => onChange(slab.id, {
          fixedAmount: e.target.value
        })} placeholder="500" data-id="element-320" />
          </div>}

        <div className="md:col-span-3" data-id="element-321">
          <Input label="Min Cap" type="number" value={slab.minCap} onChange={e => onChange(slab.id, {
          minCap: e.target.value
        })} placeholder="Optional" data-id="element-322" />
        </div>

        <div className="md:col-span-3" data-id="element-323">
          <Input label="Max Cap" type="number" value={slab.maxCap} onChange={e => onChange(slab.id, {
          maxCap: e.target.value
        })} placeholder="Optional" data-id="element-324" />
        </div>

        {/* Row 3: Tax and Actions */}
        <div className="md:col-span-11" data-id="element-325">
          <Select label="Tax (Optional)" value={slab.tax} onChange={e => onChange(slab.id, {
          tax: e.target.value
        })} options={[{
          value: '',
          label: 'No Tax'
        }, {
          value: 'FED',
          label: 'FED on Fee'
        }, {
          value: 'VAT',
          label: 'VAT on Fee'
        }]} data-id="element-326" />
        </div>

        <div className="md:col-span-1 flex items-end justify-end" data-id="element-327">
          <Button variant="ghost" size="sm" onClick={() => onRemove(slab.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" title="Remove Slab" data-id="element-328">
            <Trash2 className="h-4 w-4" data-id="element-329" />
          </Button>
        </div>
      </div>
    </div>;
}